<script setup lang="ts">
import {
  Dialog,
  DialogContent,
} from '@/components/ui/dialog'

import type { CommunicationItem } from '../types/communication'

import AnnouncementDetail from './AnnouncementDisplay/AnnouncementDetail.vue'

const props = defineProps<{
  open: boolean
  memo: CommunicationItem | null
}>()

const emit = defineEmits<{
  'update:open': [value: boolean]
  'acknowledged': [memoId: string]
  'reply': [memo: CommunicationItem]
}>()

function handleAcknowledged(communicationId: string) {
  emit('acknowledged', communicationId)
}

function handleOpenConversation() {
  emit('update:open', false)
  if (props.memo) {
    emit('reply', props.memo)
  }
}
</script>

<template>
  <Dialog :open="open" @update:open="emit('update:open', $event)">
    <DialogContent
      class="flex max-h-[85vh] min-h-0 flex-col gap-0 overflow-hidden p-0 sm:max-w-[640px]"
    >
      <div class="flex min-h-0 flex-1 flex-col overflow-hidden p-6">
        <AnnouncementDetail
          :item="memo"
          embedded
          @acknowledged="handleAcknowledged"
          @open-conversation="handleOpenConversation"
        />
      </div>
    </DialogContent>
  </Dialog>
</template>
